import { Injectable } from '@angular/core';

import { THEME_COLORS } from '../../types/theme';

@Injectable({
  providedIn: 'root',
})
export class ThemeColorService {
  generateClasses(model: string, value: string): { [key: string]: boolean } {
    return Object.keys(THEME_COLORS).reduce((classes, colorKey) => {
      return { ...classes, [`${model}-${colorKey}`]: value === colorKey };
    }, {} as { [key: string]: boolean });
  }
}
